/** Per-fixture prediction lock time (matches backend: deadline or kick-off − 30 min). */

export function getFixturePredictionDeadline(fixture) {
  if (!fixture) return null;

  if (fixture.postponed && fixture.postponement_deadline) {
    const d = new Date(fixture.postponement_deadline);
    if (!Number.isNaN(d.getTime())) return d;
  }

  if (fixture.prediction_deadline) {
    const d = new Date(fixture.prediction_deadline);
    if (!Number.isNaN(d.getTime())) return d;
  }

  if (fixture.match_date) {
    const kickoff = new Date(fixture.match_date);
    if (!Number.isNaN(kickoff.getTime())) {
      return new Date(kickoff.getTime() - 30 * 60 * 1000);
    }
  }

  return null;
}

export function isFixturePredictionOpen(fixture, now = new Date()) {
  const deadline = getFixturePredictionDeadline(fixture);
  if (!deadline) {
    const kickoff = new Date(fixture?.match_date);
    return !Number.isNaN(kickoff.getTime()) && kickoff > now;
  }
  return deadline > now;
}

/**
 * @returns {{ text: string, tone: 'closed' | 'urgent' | 'soon' | 'normal' }}
 */
export function formatClosesIn(deadline, now = new Date()) {
  if (!deadline || Number.isNaN(deadline.getTime())) {
    return { text: "", tone: "normal" };
  }

  const diffMs = deadline.getTime() - now.getTime();
  if (diffMs <= 0) {
    return { text: "Predictions closed", tone: "closed" };
  }

  const totalMins = Math.floor(diffMs / 60000);
  if (totalMins < 1) {
    return { text: "Closes in <1m", tone: "urgent" };
  }
  if (totalMins < 60) {
    return { text: `Closes in ${totalMins}m`, tone: totalMins <= 30 ? "urgent" : "soon" };
  }

  const hours = Math.floor(totalMins / 60);
  const mins = totalMins % 60;
  if (hours < 24) {
    const text =
      mins > 0 ? `Closes in ${hours}h ${mins}m` : `Closes in ${hours}h`;
    return {
      text,
      tone: hours <= 2 ? "soon" : "normal",
    };
  }

  const days = Math.floor(hours / 24);
  const remHrs = hours % 24;
  const text =
    remHrs > 0 ? `Closes in ${days}d ${remHrs}h` : `Closes in ${days}d`;
  return { text, tone: "normal" };
}

export const CLOSES_IN_TONE_CLASS = {
  closed: "bg-gray-100 text-gray-600 border-gray-200",
  urgent: "bg-amber-100 text-amber-900 border-amber-300",
  soon: "bg-amber-50 text-amber-900 border-amber-200",
  normal: "bg-white text-gray-600 border-line",
};
